// Selaimen laajuinen "ensimmäinen profiili on tallennettu" -signaali ensimmäisen hakuprofiilin
// nudgelle (IdentityReadyFab + Search-sivun pinnat). useOrganizationIdentityStatus-hook on
// instanssikohtainen: kun profiili tallennetaan yhdessä komponentissa, muiden instanssien tila
// päivittyisi vain seuraavalla pollauksella JA vain jos bäkkäri kääntää reviewStatuksen
// REVIEWED-tilaan — tavallinen profiilin tallennus (Omat profiilit, Search) ei sitä tee, joten
// "Your profile is ready!" jäi roikkumaan tallennuksen jälkeenkin. Tämä lippu vaikuttaa vain
// nudgen näkyvyyteen, ei bäkkärin tilaan.
export const IDENTITY_REVIEWED_KEY = 'tenderaIdentityReviewed';
const EVENT_NAME = 'tendera:identity-reviewed';

export const isIdentityReviewed = () => {
    try {
        return localStorage.getItem(IDENTITY_REVIEWED_KEY) === 'true';
    } catch {
        return false;
    }
};

// Kutsutaan aina kun käyttäjä tallentaa hakuprofiilin, mistä tahansa pinnasta.
export const markIdentityReviewed = () => {
    try {
        localStorage.setItem(IDENTITY_REVIEWED_KEY, 'true');
    } catch {
        // localStorage estetty — signaali kulkee silti tapahtumana tässä välilehdessä
    }
    window.dispatchEvent(new Event(EVENT_NAME));
};

// Uusi rekisteröityminen samalla selaimella: nudge saa näkyä taas.
export const resetIdentityReviewed = () => {
    try {
        localStorage.removeItem(IDENTITY_REVIEWED_KEY);
    } catch {
        // ei mitään tehtävää
    }
};

export const subscribeIdentityReviewed = (callback) => {
    const onEvent = () => callback();
    const onStorage = (e) => {
        if (e.key === IDENTITY_REVIEWED_KEY) callback();
    };
    window.addEventListener(EVENT_NAME, onEvent);
    window.addEventListener('storage', onStorage);
    return () => {
        window.removeEventListener(EVENT_NAME, onEvent);
        window.removeEventListener('storage', onStorage);
    };
};
